module.exports = __webpack_public_path__ + "static/media/icon-fashion_men.f1d00180.png";